export default __webpack_public_path__ + "static/media/qrcode-subscriber.41ece48b.svg";